import { BrowserRouter } from "react-router-dom";

import Router from "./router";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/navbar";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Router />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
